import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hometwo-banner',
  templateUrl: './hometwo-banner.component.html',
  styleUrls: ['./hometwo-banner.component.scss']
})
export class HometwoBannerComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
